import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import AsyncSelect from "react-select/lib/Async";
import moment from "moment";
import {
  addEvent,
  getSeasons,
  resetEventsError,
  updateSalesAvailability,
} from "../../../store/actions/eventsActions";
import ROUTES from "../../../constants/routes";
import { currencies } from "../../../constants/currencies";

import Container from "../../../components/UI/Container/Container";
import PageTitle from "../../../components/UI/PageTitle/PageTitle";
import CheckBox from "../../../components/UI/Checkbox/CheckBox";

import "./AddEvent.sass";
import DatePicker from "react-datepicker/es";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import withReactContent from "sweetalert2-react-content";
import NewLoader from "../../../components/NewLoader/NewLoader";
import { Counter } from "../../../components/Counter/Counter";
import { showErrorModal } from "../../../modals";
import { salesAvailabilityOptions } from "../../../constants/salesAvailabilityOptions";
import { makeElementsReadonly } from "../../../helpers/html";
import { getISODateWithTimezoneOffset } from "../../../helpers/date";

const MySwal = withReactContent(Swal);

class AddEvent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      startDate: null,
      endDate: null,
      currency: "",
      slug: "",
      isCheckingCovid: false,
      salesAvailability: salesAvailabilityOptions[0],
      activationTime: null,
      maxSeatsToSelectPerTransaction: 4,
      seasonValue: { value: 0, label: "No Season" },
    };
  }

  inputChangeHandler = (event) => {
    const { name, value } = event.target;

    this.setState({ [name]: value });
  };

  handleChange = (type, value) => {
    this.setState({ [type]: value });

    if (type === "startDate" && value) {
      const startDate = moment(value).add(1, "day").toDate();
      this.setState({
        endDate: startDate,
      });
    }
  };

  setMaxSeatsToSelectPerTransaction = (value) =>
    this.setState({
      maxSeatsToSelectPerTransaction: value,
    });
  getSeasons = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    return () =>
      this.props.getSeasons(user.token).then((data) => [
        { value: 0, label: "No Season" },
        ...data.map(({ id, seasonName }) => ({
          value: id,
          label: seasonName,
        })),
      ]);
  };

  componentDidMount() {
    // User can't enter text in Start and End date pickers
    makeElementsReadonly("react-datepicker__input-container");
  }

  componentWillUnmount() {
    this.props.resetEventsError();
  }

  addEvent = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const {
      name,
      startDate,
      endDate,
      currency,
      isCheckingCovid,
      slug,
      salesAvailability,
      activationTime,
      place,
      prefixLabel,
      maxSeatsToSelectPerTransaction,
      seasonValue,
    } = this.state;
    const { addEvent, updateSalesAvailability } = this.props;

    const isoStartDate = getISODateWithTimezoneOffset(startDate);
    const isoEndDate = getISODateWithTimezoneOffset(endDate);
    const isoActivationTime = activationTime
      ? getISODateWithTimezoneOffset(activationTime)
      : null;

    const data = {
      name,
      slug,
      prefixLabel,
      startDate: isoStartDate,
      endDate: isoEndDate,
      currency: currency.value,
      isCheckingCovid,
      place: place,
      maxSeatsToSelectPerTransaction: maxSeatsToSelectPerTransaction,
      seasonId: seasonValue.value,
    };

    if (data.name.length < 2 || data.name.length > 500) {
      MySwal.fire({
        title: "Error!",
        text: "The field Name must be a string with a minimum length of 2 and a maximum length of 500.",
        showConfirmButton: true,
        confirmButtonText: "Ok",
        type: "error",
        timer: 3000,
      });
    } else if (data.slug.length < 2 || data.slug.length > 30) {
      MySwal.fire({
        title: "Error!",
        text: "The field slug must be a string with a minimum length of 2 and a maximum length of 30.",
        showConfirmButton: true,
        confirmButtonText: "Ok",
        type: "error",
        timer: 3000,
      });
    } else {
      addEvent(data, user.token).then((response) => {
        if (response && response.id) {
          const payload = {
            salesAvailability: salesAvailability.value,
            activationTime: isoActivationTime,
          };

          updateSalesAvailability(payload, response.id, user.token).then(() => {
            this.props.history.push(ROUTES.EVENTS);
          });
        }
      });
    }
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.events.error &&
      this.props.events.error !== prevProps.error
    ) {
      toast.error(String(this.props.events.error));

      this.props.resetEventsError();
    }
  }

  render() {
    const {
      name,
      startDate,
      endDate,
      currency,
      slug,
      place,
      prefixLabel,
      salesAvailability,
      activationTime,
      maxSeatsToSelectPerTransaction,
      seasonValue,
    } = this.state;

    const customSelectStyles = {
      control: (base) => ({
        ...base,
        height: "46px",
        "min-height": "46px",
      }),
      placeholder: (base) => ({
        ...base,
        color: "#ABABAB",
      }),
    };

    return (
      <Container className="add-event">
        <div>
          <PageTitle>Add event</PageTitle>
          {this.props.events.loading ? <NewLoader isFullScreen /> : ""}
          <div className="add-event__row">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Event name</label>
                <input
                  type="text"
                  name="name"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter event name"
                  onChange={this.inputChangeHandler}
                />
              </div>
            </div>
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Venue</label>
                <input
                  type="text"
                  name="place"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter venue"
                  onChange={this.inputChangeHandler}
                />
              </div>
            </div>
          </div>

          <div className="add-event__row">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Slug</label>
                <input
                  type="text"
                  name="slug"
                  minLength="3"
                  maxLength="30"
                  placeholder="Enter slug"
                  onChange={this.inputChangeHandler}
                />
              </div>
            </div>
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Season</label>
                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  loadOptions={this.getSeasons()}
                  value={seasonValue}
                  onChange={(value) => this.handleChange("seasonValue", value)}
                  classNamePrefix="add-event__select"
                  className="add-event__select"
                  styles={customSelectStyles}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "#6071B5",
                      primary25: "#F2F4FE",
                      primary50: "#F2F4FE",
                      primary75: "#F2F4FE",
                    },
                  })}
                />
              </div>
            </div>
          </div>

          <div className="add-event__row table">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Start</label>
                <DatePicker
                  selected={startDate}
                  onChange={(event) => {
                    this.handleChange("startDate", event);
                  }}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="h:mm a d MMM yyyy "
                  timeCaption="time"
                  placeholderText="Select start date"
                />
              </div>
            </div>

            <div className="add-event__column">
              <div className="add-event__block">
                <label>End</label>
                <DatePicker
                  selected={endDate}
                  onChange={(value) => {
                    this.handleChange("endDate", value);
                  }}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="h:mm a d MMM yyyy "
                  timeCaption="time"
                  placeholderText="Select end date"
                />
              </div>
            </div>
          </div>

          <div className="add-event__row">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Currency</label>
                <Select
                  options={currencies}
                  classNamePrefix="add-event__select"
                  onChange={(value) => {
                    this.handleChange("currency", value);
                  }}
                  className="add-event__select"
                  styles={customSelectStyles}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "#6071B5",
                      primary25: "#F2F4FE",
                      primary50: "#F2F4FE",
                      primary75: "#F2F4FE",
                    },
                  })}
                  placeholder="Select currency"
                />
              </div>
            </div>
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Category</label>
                <input
                  type="text"
                  name="prefixLabel"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter event category"
                  onChange={this.inputChangeHandler}
                />
              </div>
            </div>

            {/* <div className="add-event__column">
                            <div className="add-event__block add-event__checkboxes-item">
                                <div className="checkboxes-item">
                                    <CheckBox
                                        name="isCheckingCovid"
                                        id="isCheckingCovid"
                                        checked={isCheckingCovid}
                                        onChange={() => this.setState({isCheckingCovid: !isCheckingCovid})}
                                    >
                                        Testing for COVID-19
                                    </CheckBox>
                                </div>
                            </div>
                        </div> */}
          </div>

          <div className="add-event__row">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Sales availability</label>
                <Select
                  options={salesAvailabilityOptions}
                  name="salesAvailability"
                  classNamePrefix="add-event__select"
                  value={salesAvailability}
                  defaultValue={salesAvailability}
                  onChange={(value) => {
                    this.handleChange("salesAvailability", value);
                  }}
                  className="add-event__select"
                  styles={customSelectStyles}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "#6071B5",
                      primary25: "#F2F4FE",
                      primary50: "#F2F4FE",
                      primary75: "#F2F4FE",
                    },
                  })}
                />
              </div>
            </div>

            <div className="add-event__column">
              <div className="add-event__block">
                <label>Sales start time</label>
                <DatePicker
                  selected={activationTime}
                  onChange={(value) => {
                    this.handleChange("activationTime", value);
                  }}
                  timeFormat="HH:mm"
                  showTimeSelect
                  timeIntervals={15}
                  dateFormat="h:mm a d MMM yyyy "
                  timeCaption="time"
                  placeholderText="Select activation time"
                />
              </div>
            </div>
          </div>

          <div className="add-event__row">
            <div className="add-event__column">
              <div className="add-event__block">
                <Counter
                  label="Number of tickets in one transaction"
                  value={maxSeatsToSelectPerTransaction}
                  onValueChange={this.setMaxSeatsToSelectPerTransaction}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="page-footer">
          <button
            type="button"
            className="btn-primary"
            onClick={this.addEvent}
            disabled={
              !name ||
              !startDate ||
              !endDate ||
              !salesAvailability ||
              !currency ||
              !slug ||
              !place ||
              !prefixLabel ||
              maxSeatsToSelectPerTransaction < 1
            }
          >
            Add event
          </button>
        </div>
      </Container>
    );
  }
}

AddEvent.propTypes = {};

const mapDispatchToProps = (dispatch) => ({
  addEvent: (data, userToken) => dispatch(addEvent(data, userToken)),
  resetEventsError: () => dispatch(resetEventsError()),
  updateSalesAvailability: (data, eventId, userToken) =>
    dispatch(updateSalesAvailability(data, eventId, userToken)),
  getSeasons: (userToken) => dispatch(getSeasons(userToken)),
});

export default connect(
  ({ events }) => ({ events }),
  mapDispatchToProps
)(AddEvent);
